import script from "./AssignmentResponsesDialogScanType.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssignmentResponsesDialogScanType.vue?vue&type=script&setup=true&lang=ts"

import "./AssignmentResponsesDialogScanType.vue?vue&type=style&index=0&id=38a5b2ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a5b2ea"]])

export default __exports__